<!-- 阅读页面 -->
<template>
    <el-row class="main-box">
		<el-col class="main-box-bg" :xs="{span:22,offset:1}" :sm="{span:22,offset:1}"  :md="{span:22,offset:1}" :lg="{span:20,offset:2}">
			<div class="flex-cloumn" style="height: 100%;">
			<div class="topbcls flex-row f-align-center" >
				<el-select class="content-box2-select"   v-model="courseName" placeholder="请选择"
				:popper-append-to-body="false"
				@change="selectchange">
				    <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.name">
				    </el-option>
				</el-select>
				
				<el-select class="content-box2-select" style="margin-left: 30px"  v-model="filename" placeholder="请选择"
				@change="selectchange2"
				>
				    <el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.name">
				    </el-option>
				</el-select>	
				
				 <div @click="backHandle" class="content-box2-info-btn3">返回</div>
				 
				  <div @click="shoucclick" class="content-box2-info-btn4">收藏</div>
			</div>
			
			
			
			   <div class="pdfBox flex1">
			<!-- 	 <pdf
				    id="myIframe"
				    ref="pdfDom"
				    :src="pdfSrc" 
				    :page="currentPage" 
				    @num-pages="pageCount=$event" 
				    @page-loaded="currentPage=$event" 
				    @loaded="loadPdfHandler"> </pdf>
			       -->
				  <iframe style="width: 100%;height: 100%;" ref="iframe" ></iframe>
				 </div>
			 </div>
		</el-col> 


		<el-dialog title="" :center="true" :visible.sync="dialogConfrimStartClass" :show-close="false">
		    <el-row slot="title" style="width: 100%;">
		        <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
		            <div class="appraise-popup-title flex-row f-justify-between f-align-center">
		                <div style="width:56px;height:56px;"></div>
		                <span class="appraise-popup-title-name">提示</span>
		                <img @click="dialogConfrimStartClass = false" src="../static/close.png" alt="">
		            </div>
		
		        </el-col>
		    </el-row>
		    <el-row style="width: 100%;">
		        <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
		            <div class="start-popup-content flex-column f-align-center">
		                
						   
						<el-autocomplete
						  v-model="state"
						  style="margin-top: 40px;width: 350px;height: 100px;"
						  :fetch-suggestions="querySearchAsync"
						  placeholder="请输入想收藏的单词"
						   value-key="word"
						  @select="handleSelect"
						></el-autocomplete>
						
						<el-input   style="margin-top: 20px;width: 350px;height: 100px;" v-model="input" placeholder="请输入中文"></el-input>
						
		                <div class="start-popup-content-line"></div>
		                <div class="start-popup-content-btnsbox flex-row f-justify-end" style="width:100%;">
		                    <div @click="dialogConfrimStartClass = false">返回</div>
		                    <div @click="startSubmit">收藏</div>
		                </div>
		            </div>
		
		        </el-col>
		    </el-row>
		
		</el-dialog>


    </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
// import pdf from 'vue-pdf'

// var loadingTask = pdf.createLoadingTask('https://test-jpfile1.oss-cn-shenzhen.aliyuncs.com//Bom/bom/2022/1/19/2022011911355693652034.PDF', {withCredentials: false});

export default {
	 // components: {
	 //    pdf,
	 //  },
    data() {
        return {
			datalist:[],
			courseId:"",
			courseName:"",
			studentId:"",
			options:[
			],
			filename:"",
			options2:[
			],
			documentUrl:"",
			dialogConfrimStartClass:false,
			// options3:[
			// ],
			vs:{},
			state:"",
			input:"",
			 loading: false,
			
			 }
    },
   computed: {
   ...mapState([
          'userToken',
		   'userInfos',
      ]),
      ...mapGetters(["getUserToken"])
   },
	created() {
		this.courseId = decodeURIComponent(this.$route.query.courseId);
		// this.courseName = decodeURIComponent(this.$route.query.courseName);
		this.studentId = decodeURIComponent(this.$route.query.studentId);
		    // let type = 'application/pdf';
		    //  const blob = new Blob(["https://test-jpfile1.oss-cn-shenzhen.aliyuncs.com//Bom/bom/2022/1/19/2022011911355693652034.PDF"], {type});
		    //  // 这就是blob类型文件地址 赋值给src即可展示（仅限PC端）
		    //  this.url = window.URL.createObjectURL(blob);
			// this.pdfSrc = pdf.createLoadingTask("https://cw.picimos.com/site/guihua.pdf");
			// this.pdfSrc=pdf.createLoadingTask('/static/2022011911355693652034.PDF');
		// this.loadPdfHandler();
	    this.getdatallist1();
		   
	},
    methods: {
		closeOptions(){
			 this.$refs.nameSearch.blur();
		},
		async querySearchAsync(queryString, cb)  {
			this.vs={};
			this.input="";
			if (queryString !== '') {
				 this.loading = true;
				let res = await this.$api.get("/web/frontUser/teacher/queryWordList", {
				    headers: { //头部参数
				        frontUserToken: this.getUserToken
				    },
					params:{
						word:queryString,
					 }
				});
				 this.loading = false;
				if(res.code==200)
				{
					cb(res.data);
				}
				}
		},
		handleSelect(item) {
			this.vs=item;
			this.input=this.vs.chinese;
		    console.log(item);
		},
		async startSubmit(){
			
			if(this.state=='')
			{
				this.$message({
				  type: "warning",
				  message: "请输入需要收藏的单词!"
				});
				return;
			}
			if(this.input=='')
			{
				this.$message({
				  type: "warning",
				  message: "请输入需要单词的翻译!"
				});
				return;
			}
			let res = await this.$api.post("/web/frontUser/teacher/readWordCollect",{
				chinese:this.input,
				courseId:this.courseId,
				frontUserId:this.studentId,
				word:this.state,
				wordId:this.vs.id?this.vs.id:'',
			} ,{
			    headers: { //头部参数
			        frontUserToken: this.getUserToken
			    }
			});
				if(res.code==200)
				{
					this.$message({
					  type: "success",
					  message: "收藏成功!"
					});
					this.vs={},
					this.state="",
					this.input="",
					this.dialogConfrimStartClass=false;
				}else{
					this.$message({
					  type: "warning",
					  message: res.msg
					})
				}
		},
		shoucclick(){
			this.dialogConfrimStartClass=true;
		},
		
		
		//   // 按页加载
		//     prePage() {
		//       var p = this.pageNum;
		//       p = p > 1 ? p - 1 : this.pageTotalNum;
		//       this.pageNum = p;
		//     },
		//     nextPage() {
		//       var p = this.pageNum;
		//       p = p < this.pageTotalNum ? p + 1 : 1;
		//       this.pageNum = p;
		//     },
		//     pageLoaded(e) {
		//       this.curPageNum = e;
		//     },
		//     pdfError(error) {
		//       console.error(error);
		//     },
		backHandle(){
		    this.$router.back();
		},
		//  loadPdfHandler() {
		//       this.pdfSrc.promise.then((pdf) => {
		//         this.numPages = pdf.numPages;
		//       });
		//     },
		async getdatallist1() {
			//30阅读理解学生课程下拉框
			// id	string
			// 课程id
			// name	string
			// 课程名称
			// url	string
			// 封面url
		    let res = await this.$api.get("/web/teacher/attendClass/readStudentCourseList", {
		        headers: { //头部参数
		            frontUserToken: this.getUserToken
		        },
				params:{
					studentId:this.studentId,
				 }
		    });
			if(res.code==200)
			{
			
				if(res.data!=null)
				{
					for(var i=0;i<res.data.length;i++ )
					{
						if(this.courseId==res.data[i].id){
							this.courseName=res.data[i].name;
							break;
						}
					}
					this.options=res.data;
					this.getdatallist2();
				}
			}
		},
		async getdatallist2() {
			//30阅读理解学生课程下拉框
		    let res = await this.$api.get("/web/teacher/attendClass/readStudentCourseFilesList", {
		        headers: { //头部参数
		            frontUserToken: this.getUserToken
		        },
				params:{
					courseId:this.courseId,
				 }
		    });
			if(res.code==200)
			{
				this.options2=res.data;
				if(this.options2!=null&&this.options2.length>0)
				{
					this.filename=this.options2[0].name;
					this.documentUrl=this.options2[0].documentUrl;
					var d=this.documentUrl;
					this.$refs.iframe.contentWindow.location.replace(d);
				}
			}
		},
		selectchange(data){
			console.log("!!!~~~~"+data);
			
			for(var item in this.options)
			{
				var itemdata= this.options[item];
				if(itemdata.name==data)
				{
					this.courseId=itemdata.id;
					break;
				}
			}
			this.getdatallist2();
		},
		selectchange2(data){
			for(var item in this.options2)
			{
				var itemdata= this.options2[item];
				if(itemdata.name==data)
				{
					this.documentUrl=itemdata.documentUrl;
					var d=this.documentUrl;
					this.$refs.iframe.contentWindow.location.replace(d);
					break;
				}
			}
		},
    }
}
</script>

<style lang="scss" scoped>
.main-box {
    width: 100%;
    position: relative;
	 background: #E5F3F1;

    .main-box-bg {
        height: 794px;
		border-radius: 20px;
		background: #FFFFFF;
		margin-bottom: 30px;
		margin-top: 30px;
		font-family: 思源黑体;
		font-size: 22px;
		font-weight: normal;
		line-height: 40px;
		letter-spacing: 0em;
		
		font-feature-settings: "kern" on;
		/* 333333 */
		color: #333333;
		
		overflow: hidden;
    }
	
	
	.topbcls{
		height: 80px;
		margin-left: 30px;
		margin-right: 30px;
	}
	
	.content-box2-select {
	    height: 64px;
	    border-radius: 10px;
	    opacity: 1;
	    box-sizing: border-box;
	    display: flex;
	    align-items: center;
		
		font-family: 思源黑体;
		font-size: 22px;
		font-weight: normal;
		line-height: 40px;
		letter-spacing: 0em;
		
		font-feature-settings: "kern" on;
		/* 333333 */
		color: #333333;
	}
	
	.content-box2-info-btn3 {
		margin-left: 20px;
		 cursor: pointer;
	    text-align: center;
	    width:134px;
	    height: 46px;
	    border-radius: 100px;
	
	    /* 灰 */
	    background: #ACBEB0;
	    font-family: Source Han Sans CN;
	    font-size: 18px;
	    font-weight: bold;
	    line-height: 46px;
	    text-align: center;
	    letter-spacing: 0em;
	
	    font-feature-settings: "kern" on;
	    /* 纯白 */
	    color: #FFFFFF;
	}
	
	
	.content-box2-info-btn4 {
		margin-left: 20px;
		 cursor: pointer;
	    text-align: center;
	    width:134px;
	    height: 46px;
	    border-radius: 100px;
	
	    /* 灰 */
	    	background: #0AA26B;
	    font-family: Source Han Sans CN;
	    font-size: 18px;
	    font-weight: bold;
	    line-height: 46px;
	    text-align: center;
	    letter-spacing: 0em;
	
	    font-feature-settings: "kern" on;
	    /* 纯白 */
	    color: #FFFFFF;
	}
	
	
	.pdfBox{
		width: 100%;
		height: 714px;
		padding-left: 30px;
		padding-right: 30px;
		padding-bottom: 30px;
	}
}

 ::v-deep {
    .el-input__inner{
		font-family: 思源黑体;
		font-size: 18px;
		font-weight: normal;
		letter-spacing: 0em;
		
		font-feature-settings: "kern" on;
		/* 333333 */
		color: #333333;
         &::placeholder {
          font-family: 思源黑体;
          font-size: 18px;
          font-weight: normal;
          letter-spacing: 0em;
          font-feature-settings: "kern" on;
          /* 333333 */
          color: #333333;
      }
    }
  }
 
 
 .appraise-popup-title {
     width: 100%;
     height: 86px;
     border-radius: 20px 20px 0 0;
     background: #0AA26B;
     box-sizing: border-box;
     padding: 0 35px;
 
     .appraise-popup-title-name {
         font-family: 思源黑体;
         font-size: 26px;
         font-weight: bold;
         line-height: normal;
         letter-spacing: 0em;
 
         font-feature-settings: "kern" on;
         /* 纯白 */
         color: #FFFFFF;
     }
 
     img {
         width: 56px;
         height: 56px;
     }
 }
 
 
 .start-popup-content {
     background: #fff;
     border-radius: 0 0 20px 20px;
     box-sizing: border-box;
     padding: 0 52px;
 
     .start-popup-content-text1 {
         margin-left: 173.5px;
         margin-top: 89px;
         font-family: 思源黑体;
         font-size: 22px;
         font-weight: normal;
         line-height: 40px;
         letter-spacing: 0em;
 
         font-feature-settings: "kern" on;
         /* 333333 */
         color: #333333;
     }
 
     .start-popup-content-timebox {
         margin-top: 30px;
         margin-left: 173.5px;
 
         span {
             margin-right: 30px;
             font-family: 思源黑体;
             font-size: 22px;
             font-weight: normal;
             line-height: 30px;
             letter-spacing: 0em;
 
             font-feature-settings: "kern" on;
             /* 333333 */
             color: #333333;
         }
 
         div {
             width: 195px;
             height: 64px;
             border-radius: 100px;
             opacity: 1;
 
             background: #E5F7F1;
 
             box-sizing: border-box;
             border: 1px solid rgba(10, 162, 107, 0.2);
         }
 
     }
 
     .start-popup-content-tipsbox {
         margin-top: 89px;
         margin-bottom: 75px;
         font-family: 思源黑体;
         font-size: 22px;
         font-weight: normal;
         line-height: 40px;
         letter-spacing: 0em;
 
         font-feature-settings: "kern" on;
         /* 确认开始学员 */
         color: #333333
     }
 
     .start-popup-content-line {
         margin-top: 30px;
         width: 100%;
         height: 0px;
         opacity: 1;
 
         border: 1px solid rgba(10, 162, 107, 0.2);
     }
 
     .start-popup-content-btnsbox {
         margin-top: 31px;
         margin-bottom: 30px;
 
         div {
             &:first-child {
                 margin-right: 20px;
                 width: 230px;
                 height: 64px;
                 border-radius: 100px;
                 /* 灰 */
                 background: #ACBEB0;
                 font-family: 思源黑体;
                 font-size: 28px;
                 font-weight: bold;
                 line-height: 64px;
                 text-align: center;
                 letter-spacing: 0em;
 
                 font-feature-settings: "kern" on;
                 /* 纯白 */
                 color: #FFFFFF;
             }
 
             &:last-child {
 
                 width: 230px;
                 height: 64px;
                 border-radius: 100px;
                 /* 绿 */
                 background: #0AA26B;
 
                 font-family: 思源黑体;
                 font-size: 28px;
                 font-weight: bold;
                 line-height: 64px;
                 text-align: center;
                 letter-spacing: 0em;
 
                 font-feature-settings: "kern" on;
                 /* 纯白 */
                 color: #FFFFFF;
             }
         }
     }
 
 }
 
 
 
 /deep/ .el-dialog__header {
     border-radius: 20px 20px 0 0;
     padding: 0;
 
 }
 
 /deep/ .el-dialog__body {
     border-radius: 20px;
     padding: 0;
 }
 
 /deep/ .el-dialog {
     background: transparent;
     border-radius: 20px;
     box-shadow: 0 0px 0px #ccc;
 
     @media screen and (min-width: 992px) {
         width: 44.114%;
     }
 
     @media screen and (max-width: 991px) and (min-width: 768px) {
         width: 82.395%;
     }
 
     @media screen and (max-width: 767px) {
         width: 100%;
     }
 
 
 
 
 }
 
</style>